import { ElMessage } from 'element-plus'
import router from '@/router'
const ERROR_CODE_TABLE = {
    '10001': codeFunc10001,
    '10002': codeFunc10002,
    '10003': codeFunc10003,
    '10004': codeFunc10004,
    '10006': codeFunc10006,
    '10011': codeFunc10011,
    '10012': codeFunc10012,
    '10014': codeFunc10014,
    '10015': codeFunc10015,
    '10016': codeFunc10016,
    '10017': codeFunc10017,
    '10018': codeFunc10018,
    '10019': codeFunc10019,
    '10020': codeFunc10020,
    '10021': codeFunc10021,
    '10022': codeFunc10022,
    '10023': codeFunc10023,
    '10024': codeFunc10024,
    '10025': codeFunc10025,
    '10026': codeFunc10026,
}

function codeFunc10001(){
    ElMessage({
        type: 'error',
        message: '从数据库中查询表名时出错',
        center: true
      })
}
function codeFunc10002(){
    ElMessage({
        type: 'warning',
        message: '数据库中未查询到该数据表',
        center: true
      })
}
function codeFunc10003(){
    ElMessage({
        type: 'error',
        message: '变量标签获取失败',
        center: true
      })
}
function codeFunc10004(){
    ElMessage({
        type: 'error',
        message: '查询的dash不存在',
        center: true
      })
}
function codeFunc10006(){
    ElMessage({
        type: 'error',
        message: '表中未查询到该变量',
        center: true
      })
}
function codeFunc10011(){
    ElMessage({
        type: 'error',
        message: '查询的box不存在',
        center: true
      })
}
function codeFunc10012(){
    ElMessage({
        type: 'error',
        message: '数据库中未查询到数据',
        center: true
      })
}
function codeFunc10014(){
    ElMessage({
        type: 'error',
        message: '非法时间',
        center: true
      })
}
function codeFunc10015(){
    ElMessage({
        type: 'error',
        message: '筛选配置有误',
        center: true
      })
}
function codeFunc10016(){
    ElMessage({
        type: 'error',
        message: '此dash中已存在同名box',
        center: true
      })
}
function codeFunc10017(){
    ElMessage({
        type: 'error',
        message: 'dash未创建，请先创建dash再保存box',
        center: true
      })
}
function codeFunc10018(){
    ElMessage({
        type: 'error',
        message: '用户已经创建同名的dash',
        center: true
      })
}
function codeFunc10019(){
    ElMessage({
        type: 'error',
        message: '文件上传失败',
        center: true
      })
}
function codeFunc10020(){
    ElMessage({
        type: 'error',
        message: '数据表删除失败',
        center: true
      })
}
function codeFunc10021(){
    ElMessage({
        type: 'error',
        message: '计算出错',
        center: true
      })
}
function codeFunc10022(){
    ElMessage({
        type: 'error',
        message: '对数据的删改出错',
        center: true
      })
}
function codeFunc10023(){
    ElMessage({
        type: 'error',
        message: '一键触发获取地区名称出错',
        center: true
      })
}
function codeFunc10024(){
    ElMessage({
        type: 'error',
        message: '获取一键触发信息出错',
        center: true
      })
}
function codeFunc10025(){
    ElMessage({
        type: 'error',
        message: '数据库中已存在同名表',
        center: true
      })
}
function codeFunc10026(){
    ElMessage({
        type: 'error',
        message: '一键触发失败',
        center: true
      })
}
function makeErrorHandle400(errorCode){
    ERROR_CODE_TABLE[errorCode]()
}

export {makeErrorHandle400}